import Registration from '../Client/Components/Auth/Registration';
import AuthSidebar from '../Client/Components/Auth/AuthSidebar';
import SEO from '../Client/Components/SEO';
import Scripts from '../Client/Components/Scripts';

function Register(props) {
  return (
    <div>
      <SEO title="Register" desc="Create an account for free. Free forever. No payment needed. 1LinsApp is a free and elegant link-in-bio tool for creators. Claim your name in less than a minute!" />
      <Scripts chatWidget={true} beamer={false} />
      <Registration username={props.username} />
    </div>
  );
}
export const getServerSideProps = async (context) => {
  console.log('context.query', context.query);
  let username = null;
  if (context.query.username) {
    username = context.query?.username;
  }
  return {
    props: { username },
  };
};

Register.getLayout = function getLayout(page) {
  return <AuthSidebar>{page}</AuthSidebar>;
};

export default Register;
